<template>
  <div id="form-container">
    <form id="payment-form">
      <div id="card-container"></div>
    </form>
    <ux-form-field :error="cardErrors"></ux-form-field>
  </div>
</template>

<script>
import config from "frontend/config";
// const appId = config.squareAppId;
const appId = "sq0idp-rYNeA6_-He6BYcVsrrn8PA";
const locationId = "LY7ZG9J60MWJF";

export default {
  data() {
    return {
      cardErrors: null,
    };
  },

  methods: {
    async getToken() {
      try {
        const result = await this.card.tokenize();
        if (result.status === "OK") {
          const cardData = result.details;
          const nonce = result.token;
          this.onNonceSuccess({ nonce, cardData });
        } else {
          let errorMessage = `Tokenization failed with status: ${result.status}`;
          console.log(errorMessage);
          this.onNonceFailed(errorMessage);
        }
      } catch (e) {
        console.error(e.message);
      }
    },

    async initializeCard(payments) {
      const card = await payments.card();
      await card.attach("#card-container");

      return card;
    },

    resetErrors() {
      console.log("test");
      this.cardErrors = null;
    },

    getNonce() {
      this.promise = new Promise((resolve, reject) => {
        this.onNonceSuccess = resolve;
        this.onNonceFailed = reject;
      });

      this.getToken();

      return this.promise;
    },
  },

  async mounted() {
    if (!window.Square) {
      console.log("Square.js failed to load properly");
      throw new Error("Square.js failed to load properly");
    }

    let payments;
    try {
      payments = window.Square.payments(appId, locationId);
    } catch {
      console.log(payments);
      return;
    }

    try {
      this.card = await this.initializeCard(payments);
    } catch (e) {
      console.error("Initializing Card failed", e);
      return;
    }

    const callback = async (cardInputEvent) => {
      console.log("Error removed");
      this.resetErrors();
    };
    this.card.addEventListener("errorClassRemoved", callback);

    // const cardButton = document.getElementById('card-button');
    // cardButton.addEventListener('click', async function (event) {
    //   await this.handlePaymentMethodSubmission(event, card);
    // });
  },

  beforeDestroy() {
    this.card.destroy();
  },
};
</script>
